import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function StudentCouncil() {
   const location = useLocation();
    
      // Scroll to the section if specified in the URL state
      useEffect(() => {
        if (location.state?.scrollTo) {
          const element = document.getElementById(location.state.scrollTo);
          if (element) {
            // Use smooth scrolling to the section
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [location]);
    return (
 <div className='teacherstaff-mainbox'>
       <div className='ibdp-hero-sec'>
        <img src='../img/infa.webp'/>
      </div>
 
      <div className='our-staff'>
        {/* <HorizontalTabs tabs={tabs} /> */}

        <div className='teacher-list'>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/Tanishka Purohit.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Head Girl </h2>
            <h1>Tanishka Purohit</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/Ayush Kumar.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Head Boy</h2>
            <h1>Ayush Kumar</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/Arunima singh.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Cultural Head Girl</h2>
            <h1>Arunima Singh</h1>
          
            </div>
            </div>
        </div>
     
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/SHUBHASHISH SORAL.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Cultural Head Boy</h2>
            <h1>Shubhashish Soral </h1>
          
            </div>
            </div>
        </div>
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/VAIDEHI SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Sports Head Girl</h2>
            <h1>Vaidehi Shekhawat</h1>
          
            </div>
            </div>
        </div>
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/SHUBHAM CHOUDHARY.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Sports Head Boy</h2>
            <h1>Shubham Chaudhary</h1>
          
            </div>
            </div>
        </div>
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/CHEHAK CHAWLA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Vice-Head Girl</h2>
            <h1>Chehak Chandan Chawla</h1>
          
            </div>
            </div>
        </div>
    
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/Raghav rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Vice-Head Boy</h2>
            <h1>Raghav Rathore</h1>
          
            </div>
            </div>
        </div>
    
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/TANISHKA SINGH BENIWAL.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Vice-Cultural Head Girl </h2>
            <h1>Tanishka Beniwal</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/Aryaman Singh shekhawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Vice-Cultural Head Boy </h2>
            <h1>Aaryaman Singh Shekhawat</h1>
          
            </div>
            </div>
        </div>
    
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/KARTIKA SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Vice-Sports Head Girl </h2>
            <h1>Kartika Shekhawat</h1>
          
            </div>
            </div>
        </div>
        
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/ABHISHEK SINGH SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Vice-Sports Head Boy </h2>
            <h1>Abhishek Singh Shekhawat</h1>
          
            </div>
            </div>
        </div>
 
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/PRIYANSHI MATHUR.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Captain Rig House </h2>
            <h1>Priyanshi Mathur</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/NAYAN MATHUR.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Captain Rig House </h2>
            <h1>Nayan Mathur</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/GORAL SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Vice-Captain Rig House </h2>
            <h1>Goral Shekhawat</h1>
          
            </div>
            </div>
        </div>
   

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/ROSHAN JAIN.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Vice-Captain Rig House </h2>
            <h1>Roshan Jain</h1>
          
            </div>
            </div>
        </div>
   

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/LAVANYA GUPTA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Captain Sam House </h2>
            <h1>Lavanya Gupta</h1>
          
            </div>
            </div>
        </div>
   
   

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/JAIVEER SINGH NATHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Captain Sam House</h2>
            <h1>Jaiveer Singh Nathawat</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/ROHINI SINGH.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Vice-Captain Sam House</h2>
            <h1>Rohini Singh</h1>
          
            </div>
            </div>
        </div>
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/TANMAY GUPTA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Vice-Captain Sam House </h2>
            <h1>Tanmay Gupta</h1>
          
            </div>
            </div>
        </div>
   
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/VIDHI DUSAD.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Captain Yajur House</h2>
            <h1>Vidhi Dusad</h1>
          
            </div>
            </div>
        </div>
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/JAYANT CHOUDHARY.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Captain Yajur House </h2>
            <h1>Jayant Choudhary</h1>
          
            </div>
            </div>
        </div>
   
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/ADVIKA HALDIYA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Vice-Captain Yajur House</h2>
            <h1>Advika Haldiya</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/BHAVIK PATNI.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Vice-Captain Yajur House</h2>
            <h1>Bhavik Patni</h1>
          
            </div>
            </div>
        </div>
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/UTKARSHA RATHORE.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Captain Atharva House </h2>
            <h1>Utkarsha Rathore</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/AARNA SINGH.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Captain Atharva House </h2>
            <h1>Aarna Singh</h1>
          
            </div>
            </div>
        </div>
      
      {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/BHAVESH SHARMA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Captain Atharva House  </h2>
            <h1>Bhavesh Sharma</h1>
          
            </div>
            </div>
        </div> */}
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/VINCY SHARMA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Girl Vice-Captain Atharva House</h2>
            <h1>Vincy Sharma</h1>
          
            </div>
            </div>
        </div>
      
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/MANVENDRA SINGH SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Boy Vice-Captain Atharva House </h2>
            <h1>Manvendra Shekhawat</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/TEJASVI HEMRAJ PATIL.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XI</h2>
            <h1>Tejasvi Hemraj Patil</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/VIBHUTI PAREEK.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XI</h2>
            <h1>Vibhuti Pareek</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/AASHIMA DHONI.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XI</h2>
            <h1>Aashima Dhoni</h1>
          
            </div>
            </div>
        </div>
 
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/SANJITH SUNIL.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XI</h2>
            <h1>Sanjith Sunil</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/AKSHAT KUMAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XI</h2>
            <h1>Akshat Kumawat</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/LAVISHKA JOSHI.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XI</h2>
            <h1>Aadesh Muwal</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/SURYAPRATAP SINGH.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Sports Ambassador XI</h2>
            <h1>Surya Pratap</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/KANGANA CHOUDHARY.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>School Representative XII</h2>
            <h1>Kangana Choudhary</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/MEHUL KUMAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>School Representative XII</h2>
            <h1>Mehul Kumawat</h1>
          
            </div>
            </div>
        </div>
   
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/DEVANSHI DEB.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XI </h2>
            <h1>Devanshi Deb</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/NEHAL KUMAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XI </h2>
            <h1>Manyata Nathawat</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/ANGEL MALHOTRA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XI </h2>
            <h1>Himantika Singh</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/MANASVI RATHORE.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XI </h2>
            <h1>Tanisha Jiyani</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/MANYA VYAS.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XI </h2>
            <h1>Purvi Rajpurohit</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/PRATYAKSH VERMA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XI </h2>
            <h1>Anaya Pareek</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/PURVANSH KAUSHIK.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XI </h2>
            <h1>Tanishq Sharma</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/JHANVI ARORA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XII</h2>
            <h1>Jhanvi Arora</h1>
          
            </div>
            </div>
        </div>

      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/YATHARTH PAREEK.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XII</h2>
            <h1>Yatharth Pareek</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/SARVANG PAREEK.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XII</h2>
            <h1>Sarvang Pareek</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/HIMAKSHI SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XII</h2>
            <h1>Divyansh Maheshwari</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/HIMAKSHI SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Discipline In-charges XII</h2>
            <h1>Parakram Pratap Singh</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/LAVISHKA JOSHI.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Sports Ambassador XII</h2>
            <h1>Lavishka Joshi</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/Adhiraj Mohan Lal.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Sports Ambassador XII</h2>
            <h1>Adhiraj Mohan Lal</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/NEHAL KUMAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Nehal Kumawat</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/ANGEL MALHOTRA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Angel Malhotra</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/MANASVI RATHORE.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Manasvi Rathore</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/MANYA VYAS.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Manya Vyas</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/PRATYAKSH VERMA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Pratyaksh Verma</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/PURVANSH KAUSHIK.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Purvansh Kaushik</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/RIDHIMA GUPTA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Ridhima Gupta</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/HIMAKSHI SHEKHAWAT.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Editorial Team XII </h2>
            <h1>Himakshi Shekhawat  </h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/PRIYAKSHI KAURA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Cultural Ambassador XII </h2>
            <h1> Priyakshi Kaura </h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/AARZOO SAYED.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Cultural Ambassador XI </h2>
            <h1> Aarzoo Sayed</h1>
          
            </div>
            </div>
        </div>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Student Council/ANIRUDDH BANSAL.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h2>Cultural Ambassador XII </h2>
            <h1>Aniruddh Bansal</h1>
          
            </div>
            </div>
        </div>
   
     

      
      </div>

        </div>
    
      
    </div>  
      )
    }

    export default StudentCouncil;
